import { useFilterTags } from '@aibees/elephant/feature/search-filters/components/filter-tags/hooks/use-filter-tags';
import { ChildrenFilter } from '@aibees/elephant/feature/search-filters/filters/children-filter';
import { SearchFilter } from '@aibees/elephant/feature/search-filters/types';
import { useSearchQueryFilter } from '@aibees/elephant/hooks';
import { ComingSoonTag, Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Card, CardContent, Checkbox, Typography } from '@mui/material';
import { memo } from 'react';
import { AppliedFiltersTags } from '../../../applied-filters/components/applied-filters-tags';
import * as SX from './sx';
import type { CheckboxGroupFilterItemProps as Props } from './types';

export const CheckboxGroupFilterItem = memo(
  ({ className, onChange, open, ...item }: Props) => {
    const { params } = useSearchQueryFilter({ select: [item.field!] });
    const { field, name } = item;

    const tags = useFilterTags(params, item as SearchFilter);

    const accordionMode = !tags.empty && !open;

    return (
      <Card
        className={classnames('CheckboxGroupFilterItem', className, { open })}
        sx={SX.root}
        variant="filled"
        color="default"
      >
        <CardContent padding="normal">
          {!accordionMode ? (
            <>
              <Box
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
                sx={SX.pointer}
                onClick={() => !item.comingSoon && onChange(item.field!, !open)}
              >
                <Box>
                  <Checkbox
                    name={field}
                    checked={open}
                    disabled={!!item.comingSoon}
                  />
                  <Typography
                    variant="body2"
                    color={item.comingSoon ? 'gray' : 'primary[500]'}
                  >
                    {name}
                  </Typography>
                </Box>
                {item.comingSoon && <ComingSoonTag />}
              </Box>
              <ChildrenFilter open={open} {...item} />
            </>
          ) : (
            <>
              <Box
                display={'flex'}
                flexDirection={'row'}
                justifyContent={'space-between'}
              >
                <Typography variant="body2" color="primary[500]">
                  {name}
                </Typography>
                <Icon
                  name="chevron-down"
                  size={20}
                  color="primary[500]"
                  sxx={SX.pointer}
                  onClick={() => onChange(item.field!, true)}
                />
              </Box>

              <AppliedFiltersTags tags={tags} {...item} />
            </>
          )}
        </CardContent>
      </Card>
    );
  }
);

CheckboxGroupFilterItem.displayName = 'CheckboxGroupFilterItem';
